
export const styles = (theme) => ({
    root: {
      marginTop: theme.spacing(2),
      padding : theme.spacing(3),
      width : '100%',
      boxSizing: 'border-box'
    },
    content: {
      padding: '32px 56px'
    },
    button: {
      margin: '0.5rem',
    }, 
    message: {
        marginBottom: 0,
        marginTop:0
    },
    title: {
        fontWeight: 500,
        marginTop: '3.268%',
        marginBottom: '3.268%',
        fontSize: '24px',
        textAlign: 'center',
    },
    iconCard: {
        width: '5rem'
    }
  }) 